const offeringSubmits = document.querySelectorAll(
  '[data-fp-flag=paywall-subscription-button]',
)

offeringSubmits.forEach((offeringSubmit, index) => {
  offeringSubmit.addEventListener('click', () => {
    window.submitClicked && window.submitClicked(index)
  })
})
